import { Fragment, memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { Check, Close } from '@mui/icons-material';
import { Tooltip, useEventCallback } from '@mui/material';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __OPERATION__BATCH__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import useOtp from 'shell/hooks/use-otp';
import useOtpModal from 'shell/hooks/use-otp-modal';

interface OtpButtonProps {
  marginButton?: string;
  isWithButtonNotifications?: boolean;
  isWithStyleStepButton?: boolean;
}

const OtpButtonComponent = ({
  marginButton = '0 1.5rem',
  isWithButtonNotifications,
  isWithStyleStepButton,
}: OtpButtonProps): React.ReactElement => {
  const modalOtp = useOtpModal();

  const otp = useOtp();

  const getNotifications = useHttpClient(
    `${__OPERATION__BATCH__}/jobs/ANSC_R_002_ACQUISIZIONE_NOTIFICHE_ANSC_DB_FE/startNow`,
    {
      options: {
        method: 'POST',
        loading: true,
        errorCatching: true,
      },
    }
  );

  const callGetNotifications = useEventCallback(() => {
    if (!otp.isValid) {
      return;
    }

    (getNotifications() as ResponsePromise<void>).then(() => {
      toast.success('Operazione eseguita con successo');
    });
  });

  return (
    <Fragment>
      <Tooltip
        arrow
        title={
          otp.isValid && otp.expirationTime
            ? `Scadrà entro le ${otp.expirationTime.toFormat('HH:mm')}`
            : 'OTP scaduto'
        }
      >
        {isWithStyleStepButton ? (
          <div className="pmi-pb-2" style={{ width: 'inherit', paddingLeft: '0.5rem' }}>
            <StepButton
              variant="outlined"
              color="cdmBrandThird"
              fullWidth
              onClick={() => modalOtp.toggleModal(true)}
            >
              <StepTypography>OTP</StepTypography>
              {otp.isValid ? (
                <Check color="success" fontSize="small" />
              ) : (
                <Close color="error" fontSize="small" />
              )}
            </StepButton>
          </div>
        ) : (
          <span style={{ height: 'fit-content' }}>
            <PmiButton
              variant="outlined"
              color="cdmBrandThird"
              onClick={() => modalOtp.toggleModal(true)}
              style={{ margin: marginButton }}
            >
              OTP
              {otp.isValid ? (
                <Check color="success" fontSize="small" />
              ) : (
                <Close color="error" fontSize="small" />
              )}
            </PmiButton>
          </span>
        )}
      </Tooltip>
      {isWithButtonNotifications ? (
        <span style={{ height: 'fit-content' }}>
          <PmiButton
            variant="outlined"
            color="cdmBrandThird"
            onClick={callGetNotifications}
            disabled={!otp.isValid}
            style={{ margin: marginButton }}
          >
            SCARICA NOTIFICHE RECENTI
          </PmiButton>
        </span>
      ) : undefined}
    </Fragment>
  );
};

OtpButtonComponent.displayName = 'OtpButton Component';

const OtpButton = memo(OtpButtonComponent);

export default OtpButton;
